export default __webpack_public_path__ + "static/media/Q5-1.0946a7db.jpg";